import { Injectable } from '@angular/core';

import { DataService } from '../shared/services/data.service';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateService } from '@devinforius/i-essentials';
import { GuardConfirmModalComponent } from '../components/modals/guard-confirm-modal/guard-confirm-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDeactivateScanGuard {
  constructor(
    public dialogService: DialogService,
    public dataService: DataService,
    public translate: TranslateService
  ) {}

  canDeactivate(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.dataService.checkIfUnsavedChanges === true) {
        const ref = this.dialogService.open(GuardConfirmModalComponent, {
          header: 'Confirmation',
          styleClass: 'super-compos-modal-content confirm-inforius',
          dismissableMask: false,
          width: '30em',
          data: {
            message: 'Etes-vous sûr de vouloir quitter? Les données lié au scan seront perdues.',
          },
        });
        ref.onClose.subscribe({
          next: (value) => {
            if (value) {
              if (value === true) {
                this.dataService.checkIfUnsavedChanges = false;
                resolve(true);
                localStorage.removeItem('infoFile');
              } else {
                resolve(false);
              }
            }
          },
        });
      } else {
        resolve(true);
      }
    });
  }
}
